export const blankStyle = {
  'version': 8,
  'name': 'Blank',
  'center': [
    0,
    0
  ],
  'zoom': 0,
  'sources': {},
  'sprite': 'https://cdn.jsdelivr.net/gh/lukasmartinelli/osm-liberty@gh-pages/sprites/osm-liberty',
  'glyphs': 'https://cdn.jsdelivr.net/gh/orangemug/font-glyphs@gh-pages/glyphs/{fontstack}/{range}.pbf',
  'layers': [
    {
      'id': 'background',
      'type': 'background',
      'paint': {
        'background-color': 'rgba(255,255,255,1)'
      }
    }
  ],
  'id': 'blank'
};
